import { useTranslation } from "react-i18next";
import { Header } from "src/components";
import styles from './styles.module.css';
import { toast } from 'react-toastify';
import ContactForm from './Form';
import { FaPhone, FaEnvelope } from "react-icons/fa6";
import { copyToClipBoard } from "src/utils/global";
import useScrollToTop from "src/hooks/useScrollToTop";
import { toastOptions } from "src/constants/toast";


const Contact = () => {
    const { t, i18n } = useTranslation(['contact']);
    useScrollToTop();


    const phoneCopyHandler = async (phoneNumber: string) => {
        const copied = await copyToClipBoard(phoneNumber);
        if (copied) {

            toast(t("copied"), toastOptions);
        } else {
            console.log("Error");
        }
    }


    const linkHandler = (e: React.MouseEvent<HTMLElement>, url: string) => {
        window.open(url, '_blank');
    };


    return (<main className={styles.contact}>
        <Header title={t("header.title")} />
        <section>
            <div className="container-md">
                <div className="row">
                    <div className="col-12 col-lg-8">
                        <div className={`${styles.form}`}>
                            <div className={styles.title}>
                                {t('send_msg')}
                            </div>
                            <ContactForm t={t} lang={i18n.language} />
                        </div>
                    </div>
                    <div className="col-12 col-lg-4">
                        <div className={`${styles.info__container} ${styles.card}`}>
                            <div className={styles.info}>
                                <div className={styles.title}>
                                    {t('contact_info')}
                                </div>
                                <div className={styles.infoItem} >
                                    <div className={styles.infoItemIcon}>
                                        <FaPhone />
                                    </div>
                                    <div className={styles.infoContent}>
                                        <h4>{t("info.administration.name")}</h4>
                                        <p onClick={() => phoneCopyHandler("+218920475200")}>{t('info.administration.phone')}</p>
                                    </div>
                                </div>
                                <div className={styles.infoItem} >
                                    <div className={styles.infoItemIcon}>
                                        <FaPhone />
                                    </div>
                                    <div className={styles.infoContent}>
                                        <h4>{t("info.workshop.name")}</h4>
                                        <p onClick={() => phoneCopyHandler("+218912737825")}>{t('info.workshop.phone')}</p>
                                    </div>
                                </div>
                                <div className={styles.infoItem} >
                                    <div className={styles.infoItemIcon}>
                                        <FaPhone />
                                    </div>
                                    <div className={styles.infoContent}>
                                        <h4>{t("info.sales.name")}</h4>
                                        <p onClick={() => phoneCopyHandler("+218910446856")} >{t('info.sales.phone1')}</p>
                                        <p onClick={() => phoneCopyHandler("+218930495856")}>{t('info.sales.phone2')}</p>
                                    </div>
                                </div>

                                <div className={styles.infoItem}>
                                    <div className={styles.infoItemIcon}>
                                        <FaEnvelope />
                                    </div>
                                    <div className={styles.infoContent}>
                                        <h4>{t("info.email.name")}</h4>
                                        <p onClick={(e) => linkHandler(e, `mailto:${t("info.email.value")}`)}>{t("info.email.value")}</p>
                                    </div>
                                </div>
                            </div>
                            <div className={styles.location}>
                                <iframe
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3353.129226641254!2d12.980548299999999!3d32.8153408!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x13a8e7046d29ab65%3A0xc968096befc9059!2z2LTYsdmD2Kkg2KfZhtiq2LXYp9ixINin2YTYstin2YfYsQ!5e0!3m2!1sar!2sly!4v1733428171879!5m2!1sar!2sly"

                                    height="227"
                                    style={{ border: 0 }}
                                    allowFullScreen
                                    loading="lazy"
                                    referrerPolicy="no-referrer-when-downgrade"
                                    title={"El"}
                                ></iframe>
                            </div>
                        </div>

                    </div>

                </div>
            </div>
        </section>
    </main>
    )
}

export default Contact;